export default __webpack_public_path__ + "static/media/dog-and-cat-d2.8f7b0534.svg";